module.exports = __webpack_public_path__ + "img/volleyball.f8934f1b.svg";